Flickity.prototype._createResizeClass = function () {
  this.element.classList.add("flickity-resize");
};

Flickity.createMethods.push("_createResizeClass");

var resize = Flickity.prototype.resize;
Flickity.prototype.resize = function () {
  this.element.classList.remove("flickity-resize");
  resize.call(this);
  this.element.classList.add("flickity-resize");
};

// Resize carousel after fonts have loaded to prevent issues with slide height rendering due to `font-display: swap`.
document.fonts.ready.then(() => {
  const flickityInstances = document.querySelectorAll(".flickity-enabled");
  flickityInstances.forEach((carousel) => {
    const flkty = Flickity.data(carousel);
    if (flkty) flkty.resize();
  });
});
